import { ENV, IS_LOCALHOST } from '@omni/kit/Environment';
import { KitText } from '@omni/kit/components';
import { SizeClass, useSizeClass } from '@omni/kit/contexts/SizeClassContext';
import getRouteAppKey from '@omni/kit/utilities/getRouteAppKey.web';
import React, { ReactElement } from 'react';
import { Platform, View } from 'react-native';

import { AppWrapper } from './AppWrapper';
import { MessagingProps } from './Types';
import LargeWebMessaging from './web/navigation/LargeWebMessaging';
import SmallWebMessaging from './web/navigation/SmallWebMessaging';

export default function Messaging(props: MessagingProps): ReactElement | null {
  const isSmall = useSizeClass().sizeClass === SizeClass.Small;

  let isGroups = false;

  if (typeof window !== 'undefined') {
    isGroups = window.location.href.includes('/groups');
  }

  const appKey = getRouteAppKey();

  if (!appKey) {
    return null;
  }

  if (Platform.OS === 'web' && IS_LOCALHOST && ENV === 'prod') {
    const message = `The 'prod' environment is not supported on localhost.\nPlease use 'dev' or 'stage'.`;

    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <KitText h1 center>
          {message}
        </KitText>
      </View>
    );
  }

  return (
    <AppWrapper props={{ appKey: appKey }}>
      {/* Show web navigator for medium/large screens or the group finder */}
      {!isSmall || isGroups ? (
        <LargeWebMessaging appKey={appKey} />
      ) : (
        <SmallWebMessaging {...props} appKey={appKey} />
      )}
    </AppWrapper>
  );
}
